import React, { useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import { ClearOutlined, Search, Work } from '@material-ui/icons/'
import { useKeycloak } from '@react-keycloak/web'

import listContext from '../../../../Common/context/context'
import searchContext from '../../../../PropertySearch/FiltersComponent/context/context'
import { getUserSFId, getQueryStringValue, getPollingAlertDuration, getErrorAlertDuration } from '../../../../PropertySearch/Utility/Utility'
import Chip from '../../../../Common/Chip'
import { removeSpecialCharacters, removeWhiteSpace } from '../../../../PropertySearch/Utility/Utility.js'
import { fetchDeals, addListToDeal, deleteListFromDeal } from '../../../../PropertySearch/Services/propertySearchService'
import { pollMessageStatus } from '../../../Utility/GetMessageStatus/GetMessageStatus'
import { readyToUpdate, pendingResponse } from '../../../Utility/PropertyListUtility'

const SharePropertyList = props => {
    const { setdisableClose } = props
    const { keycloak } = useKeycloak()
    let { propertyList, fetchListDetails } = useContext(listContext)

    const [modalIsOpen, setIsOpen] = useState(false)
    const [deleteDeal, setDeleteDeal] = useState(null)
    // const [confirmationMessage, setConfirmationMessage] = useState('')
    const [confirmClicked, setConfirmClicked] = useState(false)

    const [inputVal, setInputVal] = useState('')
    const [showSuggestions, isShowSuggestions] = useState(false)
    const [dealSuggestions, setDealSuggestions] = useState([])
    const [showSuggestionSpinner, setShowSuggestionSpinner] = useState(false)
    const [dealsSelected, setDealsSelected] = useState([])
    const [selectedDealObjs, setSelectedDealObjs] = useState({})
    const [existingDeals, setExistingDeals] = useState([...propertyList.sharedDeals])

    const { setShowAlert, setalertProps, fetchSavedLists, openModalWindow } = useContext(searchContext)
    const [saveClicked, setSaveClicked] = useState(false)


    const handleSelection = async (id, dealName, dealNumber) => {
        let temp = [...dealsSelected]
        let tempObj = { ...selectedDealObjs }
        if (dealsSelected.includes(id)) {
            delete temp[id]
            temp = dealsSelected.filter(propertyId => propertyId !== id)
        } else {
            tempObj[id] = {
                dealName,
                dealNumber
            }
            temp.push(id)
        }
        setSelectedDealObjs(tempObj)
        setDealsSelected(temp)
    }

    async function handleUnShare(deal) {
        setIsOpen(true)
        setDeleteDeal(deal)
        // setConfirmationMessage(`Selected ${deal.dealName} will be removed from the list ?`)        
    }

    async function confirmRemoveExistingDeal() {
        setConfirmClicked(true)
        await removeDeal(deleteDeal)
        setIsOpen(false)
        setConfirmClicked(false)
    }

    const onDelete = async (message, type) => {
        try {
            setShowAlert(false)

            switch (type) {
                case 'success':
                    fetchSavedLists()
                    await fetchListDetails()
                    // setExistingDeals([...propertyList.sharedDeals])
                    setdisableClose(false)
                    setalertProps({ message, type })
                    setShowAlert(true)

                    // setRefreshSavedSearch(!refreshSavedSearch)
                    break;

                case 'error':
                    setdisableClose(false)
                    setalertProps({ message, type, duration: getErrorAlertDuration() })
                    setShowAlert(true)
                    break;

                default: // type is warning
                    setalertProps({ message, type, duration: getPollingAlertDuration() })
                    setShowAlert(true)
                    break;
            }


        } catch (error) {
            console.log(' error in on-Delete :: ', error)
        }
    }

    async function removeDeal(deal) {
        setExistingDeals(existingDeals.map(t => {
            if (t.omniViewDealId === deal.omniViewDealId) {
                t.deleting = true
            }
            return t
        }))
        let id = deal.omniViewDealId
        const omniViewUserId = getQueryStringValue('userId')
        const list_id = propertyList.polarisPropertySearchCriteriaId// getQueryStringValue('list_id')
        const list_ov_id = propertyList.omniViewPropertyListId ? propertyList.omniViewPropertyListId : '' // getQueryStringValue('list_ov_id')
        let payload = {
            "userId": keycloak.subject,
            omniViewUserId,
            "polarisPropertySearchCriteriaId": list_id,
            "omniViewPropertyListId": list_ov_id,
            "omniViewDealId": id,
            "omniViewCompReportListId": deal.omniViewCompReportListId,
        }
        setdisableClose(true)
        let response
        if (await readyToUpdate()) {
            response = await deleteListFromDeal(payload)
        } else {
            response = await pendingResponse()
        }

        if (response && response.status === 200) {
            pollMessageStatus(response.data.messageId, onDelete, '', 'List removed from Deal !!', 'Something went wrong !!')
        } else {
            setdisableClose(false)
            const errorMessage = response.data && response.data.message ? response.data.message : 'Something went wrong !!'
            setalertProps({ message: errorMessage, type: 'error' })
            setShowAlert(true)
        }

    }
    // after share open the popup quickly... its taking time to reflect

    useEffect(() => {
        if (saveClicked) {
            handleAttachDeal()
        }
    }, [saveClicked])

    useEffect(() => {
        setExistingDeals([...propertyList.sharedDeals])
    }, [propertyList])


    useEffect(() => {
        if (inputVal.length == 0) {
            setDealSuggestions([])
        }
        if (inputVal.length >= 2) {
            inputChanged()
        }
    }, [inputVal])

    const handleChange = e => {
        let { value } = e.target
        setInputVal(value)
    }

    function inputChanged() {
        let suggestionCriteria = {}
        let payLoad = ''
        let newInputValue = inputVal
        newInputValue = removeSpecialCharacters(newInputValue)
        newInputValue = removeWhiteSpace(newInputValue)
        if (newInputValue.length >= 2) {
            setShowSuggestionSpinner(true)
            suggestionCriteria = {
                name: newInputValue,
            }
            payLoad = JSON.stringify({
                suggestion: suggestionCriteria
            })
            fetchSuggestion(payLoad)
        }
    }

    async function fetchSuggestion(payLoad) {
        const response = await fetchDeals(payLoad)
        if (response && response.status === 200) {
            if (response.data && response.data.data) {
                if (response.data.data) {
                    // const omniViewUserId = propertyList.omniViewUserId
                    let tempSugesstions = response.data.data.length ? response.data.data.filter(d => !(["Dead", "Closed", "Loan Closed"].includes(d.stageName))) : []
                    let existingUserIds = existingDeals.map(obj => obj.omniViewDealId)
                    tempSugesstions = tempSugesstions.filter(deal => !(existingUserIds.includes(deal.omniViewDealId)))
                    setDealSuggestions(tempSugesstions)
                    setShowSuggestionSpinner(false)
                    isShowSuggestions(true)
                }
            }
        }
    }

    const getPayload = () => {
        const user_SFId = getUserSFId();
        const omniViewUserId = getQueryStringValue('userId')
        const list_id = propertyList.polarisPropertySearchCriteriaId // getQueryStringValue('list_id')
        // const list_ov_id = getQueryStringValue('list_ov_id')
        let payload = {
            "userId": keycloak.subject,
            omniViewUserId,
            "polarisPropertySearchCriteriaId": list_id,
            "omniViewPropertyListId": propertyList.omniViewPropertyListId ? propertyList.omniViewPropertyListId : '',
            "listName": propertyList.name,
            "omniViewDealIds": dealsSelected,
            // 'lastModifiedById': user_SFId,
            // "polarisLastModifiedById": keycloak.subject,
            // "polarisUserName": keycloak.tokenParsed.name
        }
        return payload
    }

    const onUpdate = async (message, type) => {

        try {
            if (type === 'success') {
                await fetchListDetails()
            }
            setalertProps({ message, type, duration: type === 'error' ? getErrorAlertDuration() : '' })
            setShowAlert(true)

            openModalWindow(false)

        } catch (error) {
            console.log(' error in on-Update :: ', error)
        }

    }

    const handleAttachDeal = async () => {
        try {
            setdisableClose(false)
            let response
            if (await readyToUpdate()) {
                const payload = getPayload();
                openModalWindow(true)
                props.closeModal()
                response = await addListToDeal(payload)

            } else {
                response = await pendingResponse()
            }

            setSaveClicked(false)

            if (response && response.status === 200) {
                pollMessageStatus(response.data.messageId, onUpdate, '', 'List added to Deal !!', 'Something went wrong !!')
            } else {
                const errorMessage = response.data && response.data.message ? response.data.message : 'Something went wrong !!'
                setalertProps({ message: errorMessage, type: 'error' })
                setShowAlert(true)
            }

        }
        catch (e) {
            console.log('Error handleAddDeat to List:: ', e)
            props.closeModal()
        }
    }

    const onChipDelete = (id) => {
        let temp = { ...selectedDealObjs }
        delete temp[id]
        setSelectedDealObjs(temp)
        setDealsSelected(dealsSelected.filter(e => e !== id))
    }

    function closeModal() {
        setIsOpen(false)
    }

    const customStyles = {
        content: {
            top: '30%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -40%)',
            padding: '10px'
        },
        overlay: { zIndex: 1050 }
    }

    const isDealBeingRemoved = () => {
        return existingDeals.filter(x => x.deleting).length ? true : false
    }

    return (
        <div data-testid="test-div-container-deal-list" className='flex flex-col gap-2 shareList-box'>
            <div className='flex flex-row justify-between border-b-1 border-base p-4'>
                <div className="flex">
                    <span className='pr-4'>
                        <Work fontSize="small" />
                    </span>
                    <span className='px-2'>
                        Add Deal to list
                    </span>
                </div>
                <div>
                    <a data-testid="test-share-list-close" onClick={props.closeModal}
                        className={`${confirmClicked || isDealBeingRemoved() ? ' c-disabled pointer-events-none' : ''}`}>
                        <ClearOutlined />
                    </a>
                </div>
            </div>
            <div className="py-2 px-4 popover-w disable-scrollbars flex">
                <div className="bg-gray-5 p-3 flex rounded">
                    {showSuggestionSpinner ? <span className="loader h-6 w-6 items-center justify-center text-center absolute" ></span> : <Search className="absolute" />}
                    <input
                        data-testid="test-input-Search-deal"
                        value={inputVal}
                        style={{ width: 400 }}
                        onMouseOver={() => isShowSuggestions(true)}
                        onChange={handleChange}
                        className="shadow appearance-none pl-7 pr-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline rounded bg-gray-5"
                        type="text"
                        placeholder="Search for Deals">
                    </input>
                </div>
            </div>
            <div className="px-8 overflow-y-auto popover-w disable-scrollbars">
                {showSuggestions && <div onMouseLeave={() => isShowSuggestions(false)} className={`absolute bg-white shadow-5 overflow-y-auto ${dealSuggestions.length > 0 ? 'h-screen-25 w-1/2' : ''}`}>
                    {dealSuggestions.length > 0 ? dealSuggestions.map((deal, index) => (
                        <div data-testid={`test-deal-option-${index}`}
                            onClick={() => handleSelection(deal.omniViewDealId, deal.dealName, deal.dealNumber)}
                            role="menuitem"
                            key={deal.omniViewDealId}
                            className="flex flex-row border-b-1 border-base px-4 py-3 cursor-pointer hover:bg-gray-15">
                            <div className={dealsSelected.includes(deal.omniViewDealId) ? 'ml-2 pr-2 absolute' : 'hide ml-2 pr-2 absolute'}>&#10004;</div>
                            <div className="pl-6">
                                <div className="text-2">{deal.dealName}</div>
                                <div className="text-2">Deal Number: {deal.dealNumber}</div>
                            </div>
                        </div>))
                        :
                        ""
                    }
                </div>}
            </div>
            <div className='flex flex-col h-full'>
                <div className="p-4 flex flex-col overflow-y-auto selectedlist">
                    {dealsSelected.length ? <div className="flex flex-col">
                        <div className="px-3 text-2 font-semibold">Current Selected Deals: </div>
                        <div>
                            {dealsSelected.map((t, i) => <Chip key={t} onChipDelete={onChipDelete}
                                // name={`${selectedDealObjs[t].dealName} - ${selectedDealObjs[t].dealNumber}`} 
                                name={<a href={`${window.REACT_GLOBAL_CONFIG.SF_URL}${t}`}
                                    target="_blank"
                                    rel="noopener noreferrer">{selectedDealObjs[t].dealName} - {selectedDealObjs[t].dealNumber} </a>}
                                id={t} />)}
                        </div>
                    </div> : ''}
                    {propertyList.sharedDeals.length ? <div className="flex flex-col">
                        <div className="px-3 text-2 font-semibold">Existing Deals: </div>
                        <div>
                            {existingDeals.map((deal, index) => (
                                <span key={index} className='capitalize badge rounded-pill px-5 mr-3 mb-4 py-3 text-primary bg-gray-10'>
                                    <a href={`${window.REACT_GLOBAL_CONFIG.SF_URL}${deal.omniViewDealId}`}
                                        target="_blank"
                                        rel="noopener noreferrer">{deal.dealName} - {deal.dealNumber} </a>
                                    {deal.deleting ?
                                        <span className="-mr-3">
                                            <button className="btn bg-transparent p-0 c-disabled">
                                                <span className="customloader h-5 w-5 mx-2" ></span>
                                            </button>
                                        </span>
                                        :
                                        <span className="-mr-3">
                                            <button data-testid={`test-existing-deal-${index}`} type="button cursor-pointer" onClick={() => handleUnShare(deal)}>
                                                <i className="fa fa-close"></i>
                                            </button>
                                        </span>}
                                </span>
                            ))}
                        </div>
                    </div> : ''}
                </div>
                <div className='p-4 flex justify-end space-x-4 mt-auto border-t-1 border-base'>
                    <div>
                        <button data-testid='test-add-deal-close-button' onClick={props.closeModal} className='btn btn-sm' type='button'>
                            Close
                        </button>
                    </div>
                    {saveClicked ?
                        <button data-testid='test-button-sharing' className="btn btn-sm btn-primary c-disabled">
                            <span className="loader h-5 w-5 mx-2" ></span>
                            <span className="px-2">Adding...</span>
                        </button>
                        :
                        <button data-testid='test-button-share' onClick={() => { setSaveClicked(true) }} className={`btn btn-sm btn-primary rouded ${dealsSelected.length === 0 ? 'c-disabled' : ''}`}>Add Deal</button>
                    }
                </div>
            </div>
            <Modal ariaHideApp={false} isOpen={modalIsOpen} onRequestClose={closeModal}
                closeTimeoutMS={500} style={customStyles} >
                <div data-testid="test-delete-select-property-popup" className='flex flex-col py-4 gap-4 drawer-w'>
                    <div className='flex flex-row border-b-1 border-base pb-2'>
                        <span className='p-3'>
                            {deleteDeal && <span className='text-3'>Selected {<b>{deleteDeal.dealName}</b>} will be removed from the list ?</span>}
                        </span>
                    </div>
                    <div className='py-2 px-4'>
                        <div className='flex justify-end space-x-4 mt-auto'>
                            <div>
                                <button data-testid='test-delete-property-cancel' onClick={closeModal} className='btn btn-sm' type='button'>Close</button>
                            </div>
                            <div>
                                {confirmClicked ?
                                    <button className="btn btn-sm btn-primary c-disabled">
                                        <span className="loader h-5 w-5 mx-2" ></span>
                                        <span className="px-2">Confirm</span>
                                    </button>
                                    :
                                    <button data-testid='test-delete-deal-confirm' onClick={() => confirmRemoveExistingDeal()} className={`btn btn-sm btn-primary`}>Confirm</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default SharePropertyList

SharePropertyList.propTypes = {
    setdisableClose: PropTypes.func,
}